import EditorJs, {
  EditorProps,
} from '@/components/ui/custom/dataInput/EditorJS';
import Skeleton from '@/components/ui/custom/Skeleton';
import useCodeEditorTool from '@/data/hook/editorjs/useCodeEditorTool';
import { useImageGeneratorTool } from '@/data/hook/editorjs/useImageGeneratorTool';
import { imageGenerationGenerator } from '@/data/services/astro.ai/generateServices';
import { AspectRatioEnum } from '@/models/astro.ai/generate/Image';
import { ImageFolderEnum } from '@/models/CkEditor';

export default function MaterialEditorJS({
  value,
  onChange,
  extraBody,
  activityBlock,
  ...props
}: EditorProps) {
  const generateImage = async (prompt: string) => {
    const result = await imageGenerationGenerator({
      prompt,
      aspectRatio: AspectRatioEnum.SQUARE,
    });
    return result.imageUrl;
  };
  const { tool: imageGeneratorTool } = useImageGeneratorTool({
    onGenerateImage: generateImage,
  });

  const { isLoading: isLoadingCodeEditor, tool: codeEditorTool } =
    useCodeEditorTool();

  if (isLoadingCodeEditor) {
    return <Skeleton className="h-8 my-1 bg-primary/10 w-full rounded-lg " />;
  }

  if (props.readOnly) {
    return (
      <EditorJs
        value={value}
        onChange={onChange}
        extraBody={extraBody}
        minHeight={0}
        activityBlock={activityBlock}
        codeEditorBlock={codeEditorTool}
        imageGeneratorBlock={imageGeneratorTool}
        {...props}
      />
    );
  }

  return (
    <EditorJs
      value={value}
      onChange={onChange}
      extraBody={extraBody}
      minHeight={0}
      activityBlock={activityBlock}
      codeEditorBlock={codeEditorTool}
      imageGeneratorBlock={imageGeneratorTool}
      {...props}
      folder={ImageFolderEnum.BOOK}
    />
  );
}
